import { render, staticRenderFns } from "./leftSideBar.vue?vue&type=template&id=1597be0d"
import script from "./leftSideBar.vue?vue&type=script&lang=js"
export * from "./leftSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports